"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicesCorrectiveMeasuresPlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var queryString = require("query-string");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var operators_1 = require("rxjs/operators");
var InstalmentPaymentInfoTable_1 = require("./InstalmentPaymentInfoTable");
var PaymentInfoTable_1 = require("./PaymentInfoTable");
var InvoiceCorrectiveMeasuresHeader_1 = require("./InvoiceCorrectiveMeasuresHeader");
var PolicyVersionCoverAmountTable_1 = require("./PolicyVersionCoverAmountTable");
var InvoicesCorrectiveMeasuresPlain = /** @class */ (function (_super) {
    __extends(InvoicesCorrectiveMeasuresPlain, _super);
    function InvoicesCorrectiveMeasuresPlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState({
                loadingQueueSize: _this.state.loadingQueueSize + 1
            }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState({
                loadingQueueSize: _this.state.loadingQueueSize - 1
            }, callback);
        };
        _this.loading = function () {
            return _this.state.loadingQueueSize !== 0;
        };
        _this.state = {
            loadingQueueSize: 0
        };
        return _this;
    }
    InvoicesCorrectiveMeasuresPlain.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getInvoiceCorrectionInformation(_this.props.params.policyNumber)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (invoiceCorrectionInfo) {
                _this.setState({ invoiceCorrectionInfo: invoiceCorrectionInfo });
            });
        });
    };
    InvoicesCorrectiveMeasuresPlain.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var values = queryString.parse(this.props.location.search);
        var firstName = values.name;
        var lastName = values === null || values === void 0 ? void 0 : values.lastname;
        document.title = "".concat(firstName, " ").concat(lastName, " Invoice corrective measures");
        if (this.templates.userHasRole(["Administrator"])) {
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.loading() }), this.templates.renderHeader(), this.templates.renderBackLink("Invoices and payments page", true, "/customers/".concat(this.props.params.id, "/payments?policy=").concat(this.props.params.policyNumber)), (0, jsx_runtime_1.jsx)(InvoiceCorrectiveMeasuresHeader_1.default, { policyNumber: this.props.params.policyNumber, scenarioSupported: (_a = this.state.invoiceCorrectionInfo) === null || _a === void 0 ? void 0 : _a.supported }), (0, jsx_runtime_1.jsx)(PolicyVersionCoverAmountTable_1.default, { policyVersionCoverAmountInfo: (_b = this.state.invoiceCorrectionInfo) === null || _b === void 0 ? void 0 : _b.policyVersionCoverageAmountInfos, loading: this.loading() }), (0, jsx_runtime_1.jsx)(InstalmentPaymentInfoTable_1.default, { title: "Correct instalment plan", instalmentPaymentInfo: (_c = this.state.invoiceCorrectionInfo) === null || _c === void 0 ? void 0 : _c.effectiveInstalmentPlan, loading: this.loading() }), (0, jsx_runtime_1.jsx)(PaymentInfoTable_1.default, { title: "Actual payments", paymentInfo: (_d = this.state.invoiceCorrectionInfo) === null || _d === void 0 ? void 0 : _d.actualPayments, loading: this.loading() }), (0, jsx_runtime_1.jsx)(PaymentInfoTable_1.default, { title: "Expected payments", paymentInfo: (_e = this.state.invoiceCorrectionInfo) === null || _e === void 0 ? void 0 : _e.expectedPayments, loading: this.loading() }), (0, jsx_runtime_1.jsx)(PaymentInfoTable_1.default, { title: "Payment discrepancies (paid vs expected)", paymentInfo: (_f = this.state.invoiceCorrectionInfo) === null || _f === void 0 ? void 0 : _f.paymentDiscrepancies, loading: this.loading() }), (0, jsx_runtime_1.jsx)(PaymentInfoTable_1.default, { title: "Expected remaining payments as per correct instalment plan", paymentInfo: (_g = this.state.invoiceCorrectionInfo) === null || _g === void 0 ? void 0 : _g.expectedRemainingPayments, loading: this.loading() }), (0, jsx_runtime_1.jsx)(InstalmentPaymentInfoTable_1.default, { title: "Post-post correction instalment plan", instalmentPaymentInfo: (_h = this.state.invoiceCorrectionInfo) === null || _h === void 0 ? void 0 : _h.postCorrectionInstalmentPlan, loading: this.loading() }), (0, jsx_runtime_1.jsx)(PaymentInfoTable_1.default, { title: "Final payment discrepancies", paymentInfo: (_j = this.state.invoiceCorrectionInfo) === null || _j === void 0 ? void 0 : _j.finalPaymentDiscrepancies, loading: this.loading() })] }));
        }
        else {
            return this.templates.renderErrorPage();
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], InvoicesCorrectiveMeasuresPlain.prototype, "supportPortalService", void 0);
    InvoicesCorrectiveMeasuresPlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InvoicesCorrectiveMeasuresPlain);
    return InvoicesCorrectiveMeasuresPlain;
}(React.Component));
exports.InvoicesCorrectiveMeasuresPlain = InvoicesCorrectiveMeasuresPlain;
exports.default = (0, components_1.withRouter)(InvoicesCorrectiveMeasuresPlain);
//# sourceMappingURL=InvoiceCorrectiveMeasuresPage.js.map